import { makeAutoObservable } from 'mobx';
import { IChangeable } from '../../../stores/types';
import { INotificationToSlots } from '../emailContentTypes';
import SlotStore from './slot-store';
import TemplateStore from './template-store';

interface INotificationToSlotsChanges extends Partial<INotificationToSlots> {}

class NotificationToSlotsStore implements IChangeable<INotificationToSlotsChanges> {
	private _changes: INotificationToSlotsChanges = {};
	private _model?: INotificationToSlots;

	/** Sub-stores */
	private _slotStore?: SlotStore;

	constructor(model?: INotificationToSlots) {
		this._setModel(model);
		makeAutoObservable(this);
	}

	public get deleted() {
		return this._changes._deleted ?? false;
	}
	public get slot_id() {
		return this._changes.slot_id ?? this._model?.slot_id;
	}
	public get slot_name() {
		return this._changes.slot_name ?? this._model?.slot_name;
	}

	public get slot() {
		return this._slotStore?.getUpdatedModel();
	}

	public getContent(locale: string) {
		return this._slotStore?.getContent(locale);
	}

	public setContent(locale: string, value: string | null) {
		this._slotStore?.setContent(locale, value);
	}

	setChanges(data: INotificationToSlotsChanges) {
		this._changes = data;
		this._slotStore?.setChanges(this._changes.slot ?? {});
	}

	hasChanges(): boolean {
		return !!Object.keys(this._changes).length || !!this._slotStore?.hasChanges();
	}

	discardChanges(): void {
		this._changes = {} as INotificationToSlotsChanges;
		this._slotStore?.discardChanges();
	}

	public addTemplate(content: string | null, locale: string): TemplateStore | undefined {
		return this._slotStore?.appendTemplateStore(content, locale);
	}

	private _setModel(model?: INotificationToSlots): void {
		this._model = model;
		this._changes = {} as INotificationToSlotsChanges;

		this._slotStore = new SlotStore(model?.slot);
	}

	getUpdatedModel(): INotificationToSlots {
		const hasLocalChanges = !!Object.keys(this._changes).length;

		return {
			...this._model,
			...this._changes,
			slot: this._slotStore?.getUpdatedModel(),
			_has_changes: hasLocalChanges,
		};
	}
}

export default NotificationToSlotsStore;
